// 富文本内容区组件
<template>
  <div class="banner-frame">
    <img class="banner" v-if="!isMobile" :src="URL + bannerUrl" alt="" />
    <van-swipe v-else indicator-color="white">
      <van-swipe-item v-for="item in bannerList" :key="item.id">
        <el-image
          class="image"
          :src="URL + item.sourceUrl"
          fit="fill"
        ></el-image>
      </van-swipe-item>
    </van-swipe>

    <div class="breadcrumb" v-if="!isMobile">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span style="float: left; margin-right: 10px"
          ><i style="margin-right: 5px" class="el-icon-location-information"></i
          >您当前的位置是:</span
        >
        <el-breadcrumb-item
          :to="{ path: item.path || '' }"
          v-for="item in routeArr"
          :key="item.path"
          >{{ item.name }}</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>
import { URL } from "../util/config.js";
import { sysBannerList } from "../util/banner/banner";
export default {
  data() {
    return {
      isMobile: sessionStorage.getItem("isMobile"),
      activeName: "",
      navList: this.$store.state.navList,
      subList: this.$store.state.subList,
      formList: [],
      detail: "",
      newId: 0,
      activeCodeone: "", //
      params: {
        pageIndex: 1,
        pageSize: 10,
        newsCode: "",
        typeCode: "",
      },
      totalData: 0,
      staffList: [], //课程列表
      bannerList: [],
      aboutDetail: "", //关于我们
      URL: URL,
      bannerUrl: "",
    };
  },
  props: {
    routeArr: {
      type: Array,
      default: () => [{ name: "首页", path: "/" }],
    },
  },
  created() {
    if (this.isMobile == 1) {
      sysBannerList().then((res) => {
        this.bannerList = res.data;
      });
    }
  },
  mounted() {
    let { code } = this.$store.state;
    const nowArr = this.navList.filter((ele) => ele.code == code);
    this.bannerUrl = nowArr[0].imgUrl;
  },
  methods: {},
};
</script>
<style lang="scss">
.banner-frame {
  .banner {
    width: 100%;
    display: block;
  }

  .breadcrumb {
    border-bottom: 1px solid #ccc;
  }
  .el-breadcrumb {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
  }

  @media (max-width: 480px) {
  }
}
@media (max-width: 1300px) {
  .banner-frame {
    .el-breadcrumb {
      width: 1000px;
    }
  }
}
</style>
